import { TextField, Autocomplete, Popper } from "@mui/material";
import { AutocompleteProps } from "@mui/material";

type StyledAutocompleteProps = {
    label: string;
    factor?: number;
    appTheme?: any;
    width?: number | string;
    /** When true, show error state when input is empty. Default false so null/unselected is allowed without error. */
    errorWhenEmpty?: boolean;
} & Omit<AutocompleteProps<any, any, any, any>, 'renderInput'> & {
    /** Optional; when not provided, a default TextField is used so the selected value (e.g. chips) displays */
    renderInput?: AutocompleteProps<any, any, any, any>['renderInput'];
};

const defaultRenderInput = (params: any, label: string, factor: number, appTheme: any, errorWhenEmpty: boolean) => (
    <TextField
        {...params}
        label={label}
        variant="outlined"
        error={errorWhenEmpty ? !params.inputProps?.value : false}
        sx={{
            padding: 0,
            "& .MuiInputBase-input": {
                fontSize: 12 * factor,
                height: 12 * factor,
                padding: 1
            },
            '& .MuiOutlinedInput-root': {
                padding: '5px 10px',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: appTheme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: appTheme.palette.primary.main,
                },
            },
            '& input': { textAlign: 'left', lineHeight: 'normal' },
        }}
        inputProps={{
            ...params.inputProps,
            inputMode: "text",
            autoComplete: "off",
        }}
        InputLabelProps={{
            sx: { fontSize: 14 * factor, lineHeight: 'normal', padding: '0px 10px', backgroundColor: 'white', marginTop: '0px' },
            shrink: true
        }}
    />
);

export const StyledAutocompleteInput = ({ label, factor = 1, appTheme, width, errorWhenEmpty = false, renderInput, ...autocompleteProps }: StyledAutocompleteProps) => {
    const f = factor ?? 1;

    return (
        <Autocomplete
            {...autocompleteProps}
            sx={{
                '& .MuiAutocomplete-root': {
                    '& .MuiAutocomplete-paper .MuiAutocomplete-option:focus': {
                        borderColor: appTheme.palette.primary.main,
                    },
                },
                width: width ? width : '100%',
            }}
            renderInput={renderInput ?? ((params) => defaultRenderInput(params, label, f, appTheme, errorWhenEmpty))}
            PopperComponent={(props) => (
            <Popper {...props} autoFocus sx={{ 
                zIndex: 1300, // Ensure it appears above other elements
                '& .MuiAutocomplete-listbox': {
                    maxHeight: 200,
                    overflowY: 'auto',
                    bgcolor: 'whitesmoke',
                },
                '& .MuiAutocomplete-option': {
                    padding: '5px 10px',
                    '&:hover': {
                        backgroundColor: `${appTheme.palette.primary.extraLight} !important`,
                        borderRadius: 3
                    },
                    fontSize: 12 * f,
                },
                '& .Mui-focusVisible' : {
                        backgroundColor: `${appTheme.palette.primary.extraLight} !important`,
                        borderRadius: 3,
                },
                
            }} />
        )}
    />
    );
}